import ViewPadrao from "../views/ViewPadrao";
import UnidadeMedidaList from "../views/UnidadeMedidaList";
import UnidadeMedidaCad from "../views/UnidadeMedidaCad";

export default {
  path: "unidade-medida",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "unidade-medida-list",
      component: UnidadeMedidaList
    },
    {
      path: "novo",
      name: "unidade-medida-formulario",
      component: UnidadeMedidaCad
    },
    {
      path: "editar/:id",
      name: "unidade-medida-formulario-editar",
      component: UnidadeMedidaCad
    }
  ]
};
